export default [
  { id: 0, label: "gym" },
  { id: 1, label: "swim" },
];
